import {
  Component,
  HostBinding,
  Input,
  OnInit
} from '@angular/core';


export class SkyColumnComponent implements OnInit {
  
  public screenXSmall: number;

  
  public screenSmall: number;

  
  public screenMedium: number;

  
  public screenLarge: number;

  
  private classnames: string;

  public getClassNames(): string {
    let classnames = [
      'sky-column'
    ];

    if (this.screenXSmall) {
      classnames.push(`sky-column-xs-${this.screenXSmall}`);
    }

    if (this.screenSmall) {
      classnames.push(`sky-column-sm-${this.screenSmall}`);
    }

    if (this.screenMedium) {
      classnames.push(`sky-column-md-${this.screenMedium}`);
    }

    if (this.screenLarge) {
      classnames.push(`sky-column-lg-${this.screenLarge}`);
    }

    return classnames.join(' ');
  }

  public ngOnInit(): void {
    this.classnames = this.getClassNames();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-column',
  template: `<ng-content></ng-content>
`,
  styles: [`:host.sky-column {
  padding-right: 15px;
  padding-left: 15px;
  width: 100%;
  min-height: 1px;
}

:host.sky-column-xs-1 {
  width: 8.33333%;
}

:host.sky-column-xs-2 {
  width: 16.66667%;
}

:host.sky-column-xs-3 {
  width: 25%;
}

:host.sky-column-xs-4 {
  width: 33.33333%;
}

:host.sky-column-xs-5 {
  width: 41.66667%;
}

:host.sky-column-xs-6 {
  width: 50%;
}

:host.sky-column-xs-7 {
  width: 58.33333%;
}

:host.sky-column-xs-8 {
  width: 66.66667%;
}

:host.sky-column-xs-9 {
  width: 75%;
}

:host.sky-column-xs-10 {
  width: 83.33333%;
}

:host.sky-column-xs-11 {
  width: 91.66667%;
}

:host.sky-column-xs-12 {
  width: 100%;
}

@media (min-width: 768px) {
  :host.sky-column-sm-1 {
    width: 8.33333%;
  }
  :host.sky-column-sm-2 {
    width: 16.66667%;
  }
  :host.sky-column-sm-3 {
    width: 25%;
  }
  :host.sky-column-sm-4 {
    width: 33.33333%;
  }
  :host.sky-column-sm-5 {
    width: 41.66667%;
  }
  :host.sky-column-sm-6 {
    width: 50%;
  }
  :host.sky-column-sm-7 {
    width: 58.33333%;
  }
  :host.sky-column-sm-8 {
    width: 66.66667%;
  }
  :host.sky-column-sm-9 {
    width: 75%;
  }
  :host.sky-column-sm-10 {
    width: 83.33333%;
  }
  :host.sky-column-sm-11 {
    width: 91.66667%;
  }
  :host.sky-column-sm-12 {
    width: 100%;
  }
}

@media (min-width: 992px) {
  :host.sky-column-md-1 {
    width: 8.33333%;
  }
  :host.sky-column-md-2 {
    width: 16.66667%;
  }
  :host.sky-column-md-3 {
    width: 25%;
  }
  :host.sky-column-md-4 {
    width: 33.33333%;
  }
  :host.sky-column-md-5 {
    width: 41.66667%;
  }
  :host.sky-column-md-6 {
    width: 50%;
  }
  :host.sky-column-md-7 {
    width: 58.33333%;
  }
  :host.sky-column-md-8 {
    width: 66.66667%;
  }
  :host.sky-column-md-9 {
    width: 75%;
  }
  :host.sky-column-md-10 {
    width: 83.33333%;
  }
  :host.sky-column-md-11 {
    width: 91.66667%;
  }
  :host.sky-column-md-12 {
    width: 100%;
  }
}

@media (min-width: 1200px) {
  :host.sky-column-lg-1 {
    width: 8.33333%;
  }
  :host.sky-column-lg-2 {
    width: 16.66667%;
  }
  :host.sky-column-lg-3 {
    width: 25%;
  }
  :host.sky-column-lg-4 {
    width: 33.33333%;
  }
  :host.sky-column-lg-5 {
    width: 41.66667%;
  }
  :host.sky-column-lg-6 {
    width: 50%;
  }
  :host.sky-column-lg-7 {
    width: 58.33333%;
  }
  :host.sky-column-lg-8 {
    width: 66.66667%;
  }
  :host.sky-column-lg-9 {
    width: 75%;
  }
  :host.sky-column-lg-10 {
    width: 83.33333%;
  }
  :host.sky-column-lg-11 {
    width: 91.66667%;
  }
  :host.sky-column-lg-12 {
    width: 100%;
  }
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'screenXSmall': [{ type: Input },],
'screenSmall': [{ type: Input },],
'screenMedium': [{ type: Input },],
'screenLarge': [{ type: Input },],
'classnames': [{ type: HostBinding, args: ['class', ] },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
